import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';

import {
  createTrainingDialogue,
  editTrainingDialogue,
  getTrainingDialogue,
  getTrainingDialogues,
  removeTrainingDialogue
} from '../pageAsyncActions';

import {
  setTrainingDialogue,
  setTrainingDialogues
} from './actions';

import {
  ITrainingDialogue
} from './interfaces';

import {
  clearErrorAction,
  finishLoadingAction,
  startLoadingAction
} from '../status/actions';

import {
  createTrainingDialogueApi,
  editTrainingDialogueApi,
  getTrainingDialogueApi,
  getTrainingsDialoguesApi
} from '../api/trainings';

import {removeDialogueApi} from '../api/dialogue';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';

export const loadTrainingDialoguesAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getTrainingDialogues;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getTrainingsDialoguesApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setTrainingDialogues(data));
    } catch (e) {
      console.log('loadTrainingsDialoguesAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadTrainingDialoguesAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const loadTrainingDialogueAction = (id: number): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getTrainingDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getTrainingDialogueApi(id);

      dispatch(finishLoadingAction(actionKey));
      dispatch(setTrainingDialogue(data));
    } catch (e) {
      console.log('loadTrainingDialogueAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadTrainingDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const createTrainingDialogueAction = (dialogue: ITrainingDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    translation: {locale},
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = createTrainingDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await createTrainingDialogueApi(dialogue, locale);

      dispatch(setTrainingDialogue(data));
      dispatch(loadTrainingDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('createTrainingDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.CreateTrainingDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const editTrainingDialogueAction = (dialogue: ITrainingDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = editTrainingDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await editTrainingDialogueApi(dialogue);
      dispatch(loadTrainingDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('editTrainingDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.EditTrainingDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const removeTrainingDialogueAction = (dialogue: ITrainingDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = removeTrainingDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await removeDialogueApi(dialogue.dialogId);
      dispatch(loadTrainingDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('removeTrainingDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.RemoveTrainingDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});
